var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "90BE8714-B376-4516-AC36-2EC3C548BD84") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-589.000000, -390.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598,390 C593.032,390 589,394.032 589,399 C589,403.968 593.032,408 598,408 C602.968,408 607,403.968 607,399 C607,394.032 602.968,390 598,390 Z M598,403.5 C597.505,403.5 597.1,403.095 597.1,402.6 L597.1,399 C597.1,398.505 597.505,398.1 598,398.1 C598.495,398.1 598.9,398.505 598.9,399 L598.9,402.6 C598.9,403.095 598.495,403.5 598,403.5 Z M598.9,396.3 L597.1,396.3 L597.1,394.5 L598.9,394.5 L598.9,396.3 Z",
    id: "info"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3fb2bab7cc1cd3dd727ecd9d4dd4f22c.svg";
export { ForwardRef as ReactComponent };